export const replaceWhiteSpaceValueChange = (e: any) => {
  if (!e?.value) return;
  e?.component?.option?.('value', e?.value?.replace?.(/\s/g, ''));
};

export const replaceAllWhiteSpace = value => {
  if (!value) return value;
  return value?.replace?.(/\s/g, '');
};
